<div class="card card-custom">
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label">Pages List</h3>
    </div>
    <div class="mt-2">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput #search />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>
  <div class="card-body">
    <div class="mat-table-wrapper">
      <mat-table
        class="lmat-elevation-z8"
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="desc"
        matSortDisableClear
        style="min-width: 600px"
      >
        <ng-container matColumnDef="pageId">
          <mat-header-cell *matHeaderCellDef>Page Id</mat-header-cell>
          <mat-cell *matCellDef="let page">{{ page.pageid }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef style="justify-content: left">Email </mat-header-cell>
          <mat-cell *matCellDef="let page" style="justify-content: left">{{
            page.userEmail | titlecase
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="published">
          <mat-header-cell *matHeaderCellDef style="justify-content: left"
            >Published
          </mat-header-cell>
          <mat-cell *matCellDef="let page" style="justify-content: left">
            <span
              class="label label-inline label-light-{{
                page.published | userStatusColor
              }} font-weight-bold"
              >{{ page.published }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="userEmail">
          <mat-header-cell *matHeaderCellDef style="justify-content: left"
            >Page Name
          </mat-header-cell>
          <mat-cell *matCellDef="let page" style="justify-content: left" class="word-break">{{
            page.name | titlecase
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="appId">
          <mat-header-cell *matHeaderCellDef>App Id</mat-header-cell>
          <mat-cell *matCellDef="let page">{{ page.appid }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef>{{ 'Actions' }} </mat-header-cell>
          <mat-cell *matCellDef="let page" class="clickable">
            <button
              *ngIf="page.onKnostos && page.published"
              disabled
              type="button"
              class="btn btn-secondary btn-sm"
            >
              Deployed
            </button>
            <button
              *ngIf="!page.onKnostos && page.published"
              matTooltip="Unblock User"
              type="button"
              (click)="unblock(page)"
              class="btn btn-success btn-sm"
            >
              Deploy
            </button>
            &nbsp;
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div
        class="mat-table-message"
        *ngIf="this.dataSource.length === 0 && !loading"
        translate="GLOBAL.NO_RECORDS_FOUND"
      >
        No Records Found
      </div>
      <div class="mat-table-message" *ngIf="loading" translate="GLOBAL.PLEASE_WAIT">
        Please Wait...
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button (click)="dialogRef.close()" type="button" mat-raised-button matTooltip="Close">
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
